import React, { useState } from "react"
import { Link } from "react-router-dom"
import { Container, Row, Col } from "reactstrap"
import SoldxHeader from "../../../components/SoldxHeader"
import SoldxLandingFooter from "../../../components/SoldxLandingFooter"
import SoldxBreadcrumb from "../../../components/SoldxBreadcrumb"

const HERO_IMG =
  "https://images.unsplash.com/photo-1554435493-93422e8220c8?w=800&h=600&fit=crop"
const MARKETING_IMG =
  "https://images.unsplash.com/photo-1545324418-cc1a3fa10c00?w=800&h=500&fit=crop"
const FORM_IMG =
  "https://images.unsplash.com/photo-1564013799919-ab600027ffc6?w=600&h=500&fit=crop"

const SERVICES = [
  {
    title: "Qualified Leads",
    description:
      "Connect With Serious, Motivated Buyers To Speed Up The Seller Process And Secure The Best Deal.",
    image: "https://images.unsplash.com/photo-1552664730-d307ca884978?w=400&h=280&fit=crop",
  },
  {
    title: "High-Quality Property Visuals",
    description:
      "Feature Your Data With Stunning Property Photos, Videos, And 3D Walkthroughs To Ensure Maximum Engagement.",
    image: "https://images.unsplash.com/photo-1502672260266-1c1ef2d93688?w=400&h=280&fit=crop",
  },
  {
    title: "Transparent Competitive Bidding",
    description:
      "Reach Verified Buyers In A Live Auction Environment So You Can See Real Demand And Achieve Fair Market Value With Full Transparency.",
    image: "https://images.unsplash.com/photo-1589829545856-d10d557cf95f?w=400&h=280&fit=crop",
  },
  {
    title: "Live Property Analytics",
    description:
      "Get Real-time Insights Into Your Property's Performance, Allowing You To Make Informed Decisions During The Auction.",
    image: "https://images.unsplash.com/photo-1551434678-e076c223a692?w=400&h=280&fit=crop",
  },
]

const Seller = () => {
  const [form, setForm] = useState({
    name: "",
    email: "",
    company: "",
    mobile: "",
    state: "",
    city: "",
  })

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
    setForm((prev) => ({ ...prev, [e.target.name]: e.target.value }))
  }

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault()
    // TODO: submit to API
  }

  return (
    <div className="soldx-landing soldx-seller-page">
      <SoldxHeader solid />

      {/* Hero: rounded blue gradient box + image */}
      <section className="soldx-seller-hero soldx-hero-modern">
        <div className="soldx-hero-modern-inner">
          <div className="soldx-hero-modern-card">
            <SoldxBreadcrumb variant="hero" heroTone="dark" className="mb-5" />
            <p className="soldx-hero-modern-slogan">Maximize Your Returns</p>
            <h1 className="soldx-hero-modern-title">
              <span className="soldx-hero-modern-title-bold">Set New Standards</span>
              <span className="soldx-hero-modern-title-italic">in Property Value</span>
              <span className="soldx-hero-modern-title-bold">With SOLDX</span>
            </h1>
            <Link to="/login" className="soldx-hero-modern-cta">
              GET STARTED
            </Link>
          </div>
          <div className="soldx-hero-modern-img">
            <img src={HERO_IMG} alt="Commercial real estate" />
          </div>
        </div>
      </section>

      {/* A Partnership Built for Success */}
      <section className="soldx-seller-section soldx-seller-partnership">
        <Container>
          <div className="soldx-seller-partnership-inner">
            <h2 className="soldx-seller-section-title">A Partnership Built for Success</h2>
            <p className="soldx-seller-section-text">
              Our collaboration with sellers streamlines the auction process from listing to closing.
              We ensure transparent decisions, timely updates, and a seamless experience so you can
              focus on what matters—getting the best value for your property.
            </p>
            <Link to="/login" className="soldx-seller-btn soldx-seller-btn-primary">
              GET STARTED
            </Link>
          </div>
        </Container>
      </section>

      {/* How Auction Works For Sellers */}
      <section className="soldx-seller-section soldx-seller-steps">
        <Container>
          <h2 className="soldx-seller-steps-title">How Auction Works For Sellers</h2>
          <Row className="g-3 justify-content-center">
            <Col sm={6} md={4}>
              <div className="soldx-seller-step-tab">List Your Property</div>
            </Col>
            <Col sm={6} md={4}>
              <div className="soldx-seller-step-tab soldx-seller-step-tab--active">
                Auction Setup
              </div>
            </Col>
            <Col sm={6} md={4}>
              <div className="soldx-seller-step-tab">Market To Global Investors</div>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Drive Demand with Supercharged Marketing */}
      <section className="soldx-seller-section soldx-seller-marketing">
        <Container>
          <Row className="align-items-center g-4">
            <Col lg={6} className="order-lg-1 order-2">
              <div>
                <h2 className="soldx-seller-marketing-title">
                  Drive Demand with Supercharged Marketing
                </h2>
                <p className="soldx-seller-section-text">
                  Our comprehensive marketing strategies and dedicated digital team ensure maximum
                  exposure for your property. From targeted campaigns to global investor reach, we
                  help you attract the right buyers.
                </p>
                <Link to="/login" className="soldx-seller-btn soldx-seller-btn-primary">
                  GET STARTED
                </Link>
              </div>
            </Col>
            <Col lg={6} className="order-lg-2 order-1">
              <div className="soldx-seller-marketing-img">
                <img src={MARKETING_IMG} alt="Marketing" />
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Our Services for Sellers */}
      <section className="soldx-seller-section soldx-seller-services">
        <Container>
          <h2 className="soldx-seller-steps-title">Our Services for Sellers</h2>
          <Row className="g-4">
            {SERVICES.map((service) => (
              <Col md={6} lg={3} key={service.title}>
                <div className="soldx-seller-service-card">
                  <div className="soldx-seller-service-img">
                    <img src={service.image} alt={service.title} />
                  </div>
                  <h3 className="soldx-seller-service-title">{service.title}</h3>
                  <p className="soldx-seller-service-text">{service.description}</p>
                </div>
              </Col>
            ))}
          </Row>
        </Container>
      </section>

      {/* Contact Form */}
      <section className="soldx-seller-section soldx-seller-form-section">
        <Container>
          <Row className="align-items-center g-4">
            <Col lg={6}>
              <div className="soldx-seller-form-wrap">
                <h2 className="soldx-seller-form-title">
                  Learn More About How Soldx Help You Close More Transactions Faster And With
                  Certainty.
                </h2>
                <p className="soldx-seller-form-sub">Please enter your details.</p>
                <form onSubmit={handleSubmit} className="soldx-seller-form">
                  <input
                    type="text"
                    name="name"
                    placeholder="Name"
                    value={form.name}
                    onChange={handleChange}
                    className="soldx-seller-input"
                  />
                  <input
                    type="email"
                    name="email"
                    placeholder="Email Address"
                    value={form.email}
                    onChange={handleChange}
                    className="soldx-seller-input"
                  />
                  <input
                    type="text"
                    name="company"
                    placeholder="Company Name"
                    value={form.company}
                    onChange={handleChange}
                    className="soldx-seller-input"
                  />
                  <input
                    type="tel"
                    name="mobile"
                    placeholder="Mobile Phone"
                    value={form.mobile}
                    onChange={handleChange}
                    className="soldx-seller-input"
                  />
                  <input
                    type="text"
                    name="state"
                    placeholder="State"
                    value={form.state}
                    onChange={handleChange}
                    className="soldx-seller-input"
                  />
                  <input
                    type="text"
                    name="city"
                    placeholder="City"
                    value={form.city}
                    onChange={handleChange}
                    className="soldx-seller-input"
                  />
                  <button type="submit" className="soldx-seller-btn soldx-seller-btn-primary">
                    GET STARTED
                  </button>
                </form>
              </div>
            </Col>
            <Col lg={6}>
              <div className="soldx-seller-form-img">
                <img src={FORM_IMG} alt="Properties" />
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      <SoldxLandingFooter />
    </div>
  )
}

export default Seller
